import { render, staticRenderFns } from "./KBTextSelect.vue?vue&type=template&id=7b80ee29&scoped=true&"
import script from "./KBTextSelect.vue?vue&type=script&lang=ts&"
export * from "./KBTextSelect.vue?vue&type=script&lang=ts&"
import style0 from "./KBTextSelect.vue?vue&type=style&index=0&id=7b80ee29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80ee29",
  null
  
)

export default component.exports